module.exports = __webpack_public_path__ + "static/zz_3-3018a24e5cc0c948415ebd7f9eb4c5f0.png";